import React, { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import "./index.scss";

export default function ProjectItem(props) {
  const imgRef = useRef();

  useEffect(() => {
    const image = new Image();
    const { img } = props;
    image.src = img;
    image.onload = function() {
      imgRef.current && (imgRef.current.src = image.src);
    };
  }, [props]);

  return (
    <NavLink
      to={{
        pathname: `/projects/${props.id}`,
        state: {
          project: props.project
        }
      }}
      className="project-item"
    >
      <img
        src="https://via.placeholder.com/300"
        ref={imgRef}
        alt={`${props.img}_alt`}
      />
      <div className="project-item__mask" />
      <div className="project-item__button">
        <span>Ver proyecto</span>
      </div>
    </NavLink>
  );
}
